<template>
  <div>
    <div
      class="modal fade"
      id="modal-notify"
      aria-hidden="true"
      data-modal="scroll"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content modal-container">
          <div class="modal-body text-center p-0 modal-body-container">
            <!-- 內容區域 -->
            <div v-if="notifyList.length !== 0">
              <!-- ribbon -->
              <div
                class="my-3 ribbon-wrapper animate__animated animate__bounceIn"
              >
                <div class="mt-2 ribbon">
                  <div class="ribbon-content letter-spacing text-capitalize">
                    {{
                      notifyList[showIndex].anncmnt_type
                        .replace(/\[.*?\]/g, "")
                        .trim()
                    }}
                  </div>
                </div>
              </div>

              <!-- 通知內容 -->
              <div class="px-4">
                <div>
                  <div class="row d-flex justify-content-between">
                    <div class=""></div>
                    <div
                      class="d-flex justify-content-end"
                      v-if="notifyList.length > 1"
                    >
                      <button
                        class="btn btn-sm btn-danger mx-2"
                        :disabled="showIndex === 0"
                        @click="changeIndex('miuns')"
                      >
                        <i class="fa-solid fa-arrow-left text-white"></i>
                      </button>
                      <button
                        class="btn btn-sm btn-danger"
                        :disabled="showIndex === notifyList.length - 1"
                        @click="changeIndex('add')"
                      >
                        <i class="fa-solid fa-arrow-right text-white"></i>
                      </button>
                    </div>
                  </div>
                  <div
                    :class="getContentBg"
                    class="pt-1 d-flex justify-center align-center row px-0 mx-0 mt-1 col-12 col-sm-12 content-wrapper"
                  >
                    <div
                      class="row col-12 col-sm-12 flex justify-center align-center"
                    >
                      <div
                        class="col-12 col-sm-12 d-flex justify-center"
                        v-if="
                          notifyList[showIndex].anncmnt_type ===
                            'maintenance' ||
                          notifyList[showIndex].anncmnt_type === 'general'
                        "
                      >
                        <div
                          class="d-flex justify-center align-center rounded-circle"
                          :class="getBackground"
                        ></div>
                      </div>

                      <div
                        class="col-sm-12 justify-content-start align-centent-center my-4"
                        v-if="
                          notifyList[showIndex].anncmnt_type === 'maintenance'
                        "
                      >
                        <div class="notice-title font-weight-bold">
                          {{
                            $t(
                              "the-system-maintenance-will-be-held-in-order-to-provide-the-best-user-experience-for-you-thank-you"
                            )
                          }}
                        </div>
                        <div class="notice-subtitle font-weight-bold mt-4">
                          {{ $t("start-time") }}:
                          {{ notifyList[showIndex].start }}
                        </div>
                        <div class="notice-subtitle font-weight-bold">
                          {{ $t("end-time") }}: {{ notifyList[showIndex].end }}
                        </div>
                      </div>
                      <div
                        v-else
                        class="px-0 col-sm-12 align-center justify-content-start"
                      >
                        <span
                          v-html="notifyList[showIndex].anncmnt_content"
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 無通知時顯示 -->
            <div
              v-else
              class="d-flex align-items-center justify-content-center"
              style="height: 440px"
            >
              <div>
                <img :src="img_no_notify" alt="" style="width: 260px" />
                <h1 class="l-text">No unread threads</h1>
              </div>
            </div>
          </div>

          <!-- 底部按鈕 -->
          <div class="modal-footer">
            <button
              id="notify_ok"
              @click="closeModal()"
              type="button"
              class="btn btn-primary"
            >
              {{ $t("ok") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import dayjs from "dayjs";
import { onMounted, watch } from "vue";
import { ApiGetNotify } from "@/service/apis/learninfo.js";
import { useGlobalStore } from "@/store/modules/global";
const global = useGlobalStore();
const closeModal = () => {
  console.log("close modal");
  global.$patch((state) => {
    state.showNotification = false;
  });
  $(`#modal-notify`).modal("hide");
};
const showIndex = ref(0);
const notifyList = ref([]);
const getNotify = async () => {
  let todayTimestamp = Math.floor(Date.now() / 1000);
  const result = await ApiGetNotify.get();
  notifyList.value = [];
  if (result.status === "success") {
    notifyList.value = result.record.filter((element) => {
      const type = element.anncmnt_type || "";
      if (type.includes("[Student]")) return true;
      return !/\[.*?\]/.test(type);
    });
    notifyList.value.forEach((element) => {
      let startTime = Number(element.start_date + "000");
      let endTime = Number(element.end_date + "000");
      element.start = dayjs(startTime).format("YYYY/MM/DD HH:mm");
      element.end = dayjs(endTime).format("YYYY/MM/DD HH:mm");
    });
  }
  if (notifyList.value.length !== 0 && global.showNotification === true) {
    $(`#modal-notify`).modal({
      backdrop: "static",
      keyboard: false,
      show: true,
    });
  }
};

// 監聽 global.showNotification 的變化，當它變為 true 時獲取通知
watch(
  () => global.showNotification,
  (newVal) => {
    if (newVal === true) {
      getNotify();
    }
  }
);

const img_no_notify = computed(() => {
  return new URL(
    `/src/assets/img/balloon_No unread threads.png`,
    import.meta.url
  ).href;
});
const disabledBackbtn = computed(() => {
  return showIndex.value === 0;
});
const disabledfrontbtn = computed(() => {
  return showIndex.value === notifyList.value.length - 1;
});
const getBackground = computed(() => {
  if (notifyList.value[showIndex.value].anncmnt_type === "general") {
    return "notice-bg ";
  } else {
    return "maintenance-bg";
  }
});
const getContentBg = computed(() => {
  if (notifyList.value[showIndex.value].anncmnt_type === "general") {
    return "notice-content ";
  } else {
    return "maintenance-content";
  }
});
const changeIndex = (type) => {
  console.log(notifyList.value.length);
  if (type === "add") {
    if (showIndex.value !== notifyList.value.length - 1) {
      showIndex.value = showIndex.value + 1;
    }
  } else {
    if (showIndex.value !== 0) {
      showIndex.value = showIndex.value - 1;
    }
  }
};
onMounted(() => {
  // $("#modal-notify").modal({ backdrop: "static", Keyboard: false });
  getNotify();
});
</script>
<style lang="scss" scoped>
.modal-container {
  min-height: 300px;
  max-height: 90vh; // 視窗高度的90%
  display: flex;
  flex-direction: column;
}

.modal-body-container {
  flex: 1;
  overflow-y: auto;
  padding: 1rem;
  min-height: 200px;
  max-height: calc(90vh - 100px); // 減去header和footer的預估高度
}

.content-wrapper {
  min-height: 100px;
  max-height: 100%;
  overflow-y: auto;
  padding: 1rem;
}

.maintenance-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1.5rem;
  overflow-y: auto;

  // 確保內容不會超出容器
  img {
    max-width: 100%;
    height: auto;
  }
}

.notice-content {
  padding: 1.5rem;
  overflow-y: auto;

  // 確保內容不會超出容器
  img {
    max-width: 100%;
    height: auto;
  }

  // 處理長文本
  span {
    word-break: break-word;
    white-space: pre-wrap;
  }
}

// 針對不同螢幕尺寸的響應式調整
@media (max-width: 768px) {
  .modal-container {
    min-height: 200px;
    max-height: 95vh;
  }

  .modal-body-container {
    padding: 0.5rem;
  }

  .content-wrapper {
    padding: 0.5rem;
  }
}
</style>
